<template>
  <!-- star -->
  <div class="homepage_wrap">
    <!-- banner图和导航栏 -->
    <navigation></navigation>
    <banner :imgList="bannerList"></banner>
    <!-- 全方位的解决方案 -->
    <div class="solution">
      <h1>全方位的解决方案</h1>
      <div class="solution-item">
        <div class="solution-item1" style=" float: left;">
          <span><img class="solution-img" src="../assets/img/home/solution_monitor.png"
                     @mouseover="onHover" :style="{ transition: Transition,transform: Transform }"/></span>
          <p class="solution-text">健康监测</p>
          <p class="solution-text2">
            &nbsp;&nbsp;&nbsp;Monitor
          </p>
        </div>
        <div class="solution-item1" style=" float: left;">
          <span><img class="solution-img" src="../assets/img/home/solution_evaluating.png"
                     @mouseover="onHover2" :style="{ transition: Transition2 }"/></span>
          <p class="solution-text">心理测评</p>
          <p class="solution-text3">
            Evaluating
          </p>
        </div>
        <div class="solution-item1" style=" float: left;">
          <span><img class="solution-img" src="../assets/img/home/solution_train.png"
                     @mouseover="onHover3" :style="{ transition: Transition3 }"/></span>
          <p class="solution-text">心理训练</p>
          <p class="solution-text4">
            &nbsp;&nbsp;&nbsp;Train
          </p>
        </div>
        <div class="solution-item1" style=" float: left;">
          <span><img class="solution-img" src="../assets/img/home/solution_soothing.png"
                     @mouseover="onHover4" :style="{ transition: Transition4 }"/></span>
          <p class="solution-text">心理舒缓</p>
          <p class="solution-text4">
            Soothing
          </p>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="scheme" v-show="showA">
      <div class="scheme_cont">
        <div class="scheme_item">
          <div class="scheme_item1">
            <img src="../assets/img/home/health_monitor.png"/>
            <div class="scheme_item_text">
              <h2>健康监测<br/>
                <h3>Health monitor</h3></h2>
              <span>实时生理监测，自研的自主神经传感器能无创和精确地对心率、血氧饱和度、HRV等生理指标实时和连续监测及数据采集，通过指标深度运算，定量化对自主神经系统进行评估，及进一步的心理健康分析及反馈。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scheme" v-show="showB">
      <div class="scheme_cont">
        <div class="scheme_item">
          <div class="scheme_item1">
            <img src="../assets/img/home/psychological_assessment.png"/>
            <div class="scheme_item_text">
              <h2>心理测评<br/>
                <h3>Psychological assessment</h3></h2>
              <span>使用专业量表，包含心理卫生宗合评定、行为、气质、抑有、焦虑、孤独、人际关系、社交、精神障碍、自我意识、生活事件等，可根据需求定制特殊量表及指定量表的更新，对个体的能力、自我、适应、人际关系、智力、职业生涯等方面进行全面评估，了解个体心理健康状况，建立心理健康教育档案，实现个体与社会的衔接。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scheme" v-show="showC">
      <div class="scheme_cont">
        <div class="scheme_item">
          <div class="scheme_item1">
            <img src="../assets/img/home/psychological_training.png"/>
            <div class="scheme_item_text">
              <h2>心理训练<br/>
                <h3>Psychological training</h3></h2>
              <span>采用3D立体声、全景展示等技术，将用户带入虚拟世界中，并在其中提供专业的心理治疗和辅导服务。通过虚拟现实技术，可以在用户感觉安全、舒适的环境中，对抗各种心理问题，如焦虑、恐慌、压力等。用户可以选择不同的场景和体验方式，包括沉浸式体验、角色扮演、音乐疗法等，根据个人需求进行心理治疗和辅导。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scheme" v-show="showD">
      <div class="scheme_cont">
        <div class="scheme_item">
          <div class="scheme_item1">
            <img src="../assets/img/home/psychological_soothing.png"/>
            <div class="scheme_item_text">
              <h2>心理舒缓<br/>
                <h3>Psychological soothing</h3></h2>
              <span>集生物反馈、放松训练、心理课堂、音乐放松为一体，通过自然音乐、全息脑波音乐、专业呼吸训续课程来缓解和调节心理和精神的上的压力，在放松身心的同时理河实时监测并采集心率、HRV等，根据心率变通过呼吸、肌体放松等主动进行自我调节，达到深度放松。</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 热门产品推荐 -->
    <div class="product">
      <div class="product-top"></div>
      <h1>热门产品推荐</h1>
      <div class="product-line"></div>
      <!--旧版-->
      <!--      <div class="product-carousel">-->
      <!--        <el-carousel arrow="always" :autoplay="false">-->
      <!--          <el-carousel-item v-for="(item, index3) in productList" :key="index3" style="width: 100%;height: 100%;">-->
      <!--            <el-image fit="cover" :src="item.proImg"></el-image>-->
      <!--            <div class="product_item_text">-->
      <!--              <h2>{{ item.proTitle }}<br/>-->
      <!--                <h3>{{ item.proSubTitle }}</h3></h2>-->
      <!--              <span>{{ item.proContent }}</span>-->
      <!--              <div class="product_div">-->
      <!--                <img class="product_img" :src="item.proContentImg"/>&nbsp;&nbsp;&nbsp;-->
      <!--                <img class="product_img2" :src="item.proContentImg2"/>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </el-carousel-item>-->
      <!--        </el-carousel>-->
      <!--      </div>-->

      <div class="product-content">
        <div class="product-content-bottom" @click="arrowLeftClick()">
          <img src="../assets/img/home/arrow_left.png">
        </div>
        <div class="product-content-item" v-show="itemIndex==1">
          <div class="product-content-left" v-show="currentIndex==1">
            <img src="../assets/img/home/recommend_product_max.png">
          </div>
          <div class="product-content-left" v-show="currentIndex==2">
            <img src="../assets/img/home/recommend_product_max2.png">
          </div>
          <div class="product-content-right">
            <div class="product-content-right-1">
              <div class="div1More" @click="moreClick"><h5>More...</h5></div>
            </div>
            <div class="product-content-right-2">
              <h2>心理压力评测训练系统<br/>
                <h3>(HY-S1型)</h3></h2>
              <span>采用柔性硅胶加FPC工艺，具备双导脑电、双路脉搏波同步监测，实现脑电分析、hrv心率变异性分析、情绪和精神压力分析、实时血氧、心率、血流灌注指数计算，血管弹性分析。</span>
              <div class="product_div2">
                <div class="product_img_mini_div1" @click="onClick(1)" :class="{ active: currentIndex === 1 }">
                  <img class="product_img3" src="../assets/img/home/recommend_product_mini.png"/>
                </div>
                <div class="product_img_mini_div2" @click="onClick(2)" :class="{ active: currentIndex === 2 }">
                  <img class="product_img4" src="../assets/img/home/recommend_product_mini2.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-content-item" v-show="itemIndex==2">
          <div class="product-content-left" v-show="currentIndex2==1">
            <img src="../assets/img/home/recommend_product2_max.png">
          </div>
          <div class="product-content-left" v-show="currentIndex2==2">
            <img src="../assets/img/home/recommend_product2_max2.png">
          </div>
          <div class="product-content-right">
            <div class="product-content-right-1">
              <div class="div1More" @click="moreClick2"><h5>More...</h5></div>
            </div>
            <div class="product-content-right-2">
              <h2>心理压力评测训练系统<br/>
                <h3>(HY-S1-II型)</h3></h2>
              <span>采用柔性硅胶加FPC工艺，具备双导脑电、双路脉搏波同步监测，实现脑电分析、hrv心率变异性分析、情绪和精神压力分析、实时血氧、心率、血流灌注指数计算，血管弹性分析。</span>
              <div class="product_div2">
                <div class="product_img_mini_div1" @click="onClick2(1)" :class="{ active: currentIndex2 === 1 }">
                  <img class="product_img3" src="../assets/img/home/recommend_product2_mini.png"/>
                </div>
                <div class="product_img_mini_div2" @click="onClick2(2)" :class="{ active: currentIndex2 === 2 }">
                  <img class="product_img4" src="../assets/img/home/recommend_product2_mini2.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-content-item" v-show="itemIndex==3">
          <div class="product-content-left" v-show="currentIndex3==1">
            <img src="../assets/img/home/recommend_product3_max.png">
          </div>
          <div class="product-content-left" v-show="currentIndex3==2">
            <img src="../assets/img/home/recommend_product3_max2.png">
          </div>
          <div class="product-content-right">
            <div class="product-content-right-1">
              <div class="div1More" @click="moreClick3"><h5>More...</h5></div>
            </div>
            <div class="product-content-right-2">
              <h2>心理压力评测训练系统<br/>
                <h3>(HY-S3型)</h3></h2>
              <span>采用血氧、呼吸、皮电复合传感器一体式设计，包含红光和红外光脉搏信号，250HZ采样频率、LEMO锁式接口，可监测分析心率、稳定指数、抗压能力、自主神经、呼吸波形、皮肤电阻、脉搏波和PPG的实时动态指数等。</span>
              <div class="product_div2">
                <div class="product_img_mini_div1" @click="onClick3(1)" :class="{ active: currentIndex3 === 1 }">
                  <img class="product_img3" src="../assets/img/home/recommend_product3_mini.png"/>
                </div>
                <div class="product_img_mini_div2" @click="onClick3(2)" :class="{ active: currentIndex3 === 2 }">
                  <img class="product_img4" src="../assets/img/home/recommend_product3_mini2.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-content-bottom2" @click="arrowRightClick()">
          <img src="../assets/img/home/arrow_right.png">
        </div>
      </div>
      <div class="product-bottom">
        <div class="product-bottom-item1" :class="{ active: itemIndex === 1 }"></div>
        <div class="product-bottom-item2" :class="{ active: itemIndex === 2 }"></div>
        <div class="product-bottom-item3" :class="{ active: itemIndex === 3 }"></div>
      </div>

      <div class="story_item">
        <img src="../assets/img/home/home_story.png"/>
        <div class="story_item_text">
          <h1>品牌故事 <span>Brand Story</span></h1>
          <p>
            奥佳华智能健康科技集团股份有限公司创立于1996年，总部设在厦门。2011年9月9日，在深圳交易所挂牌上市（股票代码：002614.SZ），公司涵盖了保健按摩、健康环境、家用医疗等多个产业模块，是集研发、制造、品牌、营销、服务为一体的国际化智能健康产业集团。公司主导筹建的中医智能推拿按摩健康（中国）院研究，重点从事健康智库、推拿大师手法数字化采集与实现等研究。目前，公司拥有七大产业基地，产品遍及全球80多个国家和地区。集团依托20多年大健康领域经验，布局健康心理领域，慧云品牌由此而生。
          </p>
          <p>
            厦门慧云柏科智能科技有限公司是奥佳华集团全资子公司，是一家专业从事心理素质教育软硬件产品研制生产、方案设计、培训交流和学术研究于一体的应用心理学领域的专业机构，可提供心理服务中心一站式整体化解决方案。
          </p>
          <p>
            产品品类包含：智慧心理大数据SAAS云平台、生物反馈训练系统、VR虛拟现实训练系统、CSR心理应激评估训练系统、团体脑电心理疏导系统、多维智能击打呐喊宣泄系统等产品，业务覆盖军队、公安、司法、学校、企事业等单位。
          </p>
          <div class="story_more_div">
            <span class="story_more_p" @click="moreClick4">More ▶</span>
          </div>
        </div>
      </div>
    </div>
    <!--品牌故事-->
    <div class="story">
    </div>
    <!--品牌服务-->
    <!--    <div class="service">-->
    <!--      <h1>品牌服务</h1>-->
    <!--      <h2>Service Support</h2>-->
    <!--      <div class="service_cont">-->
    <!--        <div class="service_item">-->
    <!--          <div class="service_item1">-->
    <!--            <div class="service_item_text">-->
    <!--              <div class="service_item_text2">-->
    <!--                <img class="service_img" src="../assets/img/home/home_service.png"/>-->
    <!--              </div>-->
    <!--              <img class="service_contact_img" src="../assets/img/home/home_contact.png"/>-->
    <!--            </div>-->
    <!--            <img class="service_partners_img" src="../assets/img/home/home_partners.png"/>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--成功案例-->
    <div class="success">
      <h1>客户体验</h1>
      <h2>customer experience</h2>
    </div>
    <div class="case">
      <div class="carouselBox">
        <el-carousel :loop="true" :autoplay="true" arrow="never" class="carousel">
          <el-carousel-item class="el-car-item" v-for="(list, index) in dataList" :key="index">
            <div v-for="(imgList,index1) in list" :key="index1" class="divSrc">
              <img class="img" :src="imgList.img"/>
              <div class="title">{{ imgList.title }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- footer -->
    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import banner from "../components/banner.vue";
import footer2 from "../components/footer.vue";

export default {
  name: "index",
  components: {
    navigation,
    banner,
    footer2,
  },
  data() {
    return {
      bannerList: [
        // {
        //   imgUrl: require('@/assets/img/home/home_banner.png')
        // },
        {
          imgUrl: require('@/assets/img/home/home_banner2.png')
        },
        {
          imgUrl: require('@/assets/img/home/home_banner3.png')
        },
        {
          imgUrl: require('@/assets/img/home/home_banner4.png')
        }
      ],
      productList: [
        {
          proImg: require('@/assets/img/home/home_product.png'),
          proTitle: "心理压力评测训练系统",
          proSubTitle: '(HY-S1型)',
          proContent: "采用柔性硅胶加FPC工艺，具备双导脑电、双路脉搏波同步监测，实现脑电分析、hrv心率变异性分析、情绪和精神压力分析、实时血氧、心率、血流灌注指数计算，血管弹性分析。",
          proContentImg: require('@/assets/img/home/home_product_1.png'),
          proContentImg2: require('@/assets/img/home/home_product_2.png')
        },
        {
          proImg: require('@/assets/img/home/home_product2.png'),
          proTitle: "心理压力评测训练系统",
          proSubTitle: '(HY-S1-II型)',
          proContent: "采用柔性硅胶加FPC工艺，具备双导脑电、双路脉搏波同步监测，实现脑电分析、hrv心率变异性分析、情绪和精神压力分析、实时血氧、心率、血流灌注指数计算，血管弹性分析。",
          proContentImg: require('@/assets/img/home/home_product2_1.png'),
          proContentImg2: require('@/assets/img/home/home_product2_2.png')
        },
        {
          proImg: require('@/assets/img/home/home_product3.png'),
          proTitle: "心理压力评测训练系统",
          proSubTitle: '(HY-S3型)',
          proContent: "采用血氧、呼吸、皮电复合传感器一体式设计，包含红光和红外光脉搏信号，250HZ采样频率、LEMO锁式接口，可监测分析心率、稳定指数、抗压能力、自主神经、呼吸波形、皮肤电阻、脉搏波和PPG的实时动态指数等。",
          proContentImg: require('@/assets/img/home/home_product3_1.png'),
          proContentImg2: require('@/assets/img/home/home_product3_2.png')
        }
      ],
      //dataHeight: '410px',
      Transform: 'scale(1.2)',
      Transition: '',
      Transition2: '',
      Transition3: '',
      Transition4: '',
      showA: true,
      showB: false,
      showC: false,
      showD: false,
      dataList: [],
      itemIndex: 1,
      currentIndex: 1,
      currentIndex2: 1,
      currentIndex3: 1
    };
  },
  mounted() {
    this.byEvents();
  },
  computed: {
    title() {
      return this.$store.state.title;
    },
  },
  methods: {
    byEvents() {
      this.dataList = [{
        img: require("../assets/img/home/home_new1.jpg"), //require('../../assets/img/profile/message.svg')
        //title: '标题1'
      },
        {
          img: require("../assets/img/home/home_new3.jpg"),
          //title: '标题2'
        },
        {
          img: require("../assets/img/home/home_new2.jpg"),
          //title: '标题3'
        },
        {
          img: require("../assets/img/home/home_new4.jpg"),
        },
        {
          img: require("../assets/img/home/home_new5.jpg"),
        },
        {
          img: require("../assets/img/home/home_new6.jpg"),
        },
        {
          img: require("../assets/img/home/home_new7.jpg"),
        },
        {
          img: require("../assets/img/home/home_new8.jpg"),
        },
        {
          img: require("../assets/img/home/home_new9.jpg"),
        },
        {
          img: require("../assets/img/home/home_new10.jpg"),
        },
        {
          img: require("../assets/img/home/home_new11.jpg"),
        },
        {
          img: require("../assets/img/home/home_new12.jpg"),
        },
        {
          img: require("../assets/img/home/home_new13.jpg"),
        },
        {
          img: require("../assets/img/home/home_new14.jpg"),
        },
        {
          img: require("../assets/img/home/home_new15.jpg"),
        },
        {
          img: require("../assets/img/home/home_new16.jpg"),
        },
        {
          img: require("../assets/img/home/home_new17.jpg"),
        },
        {
          img: require("../assets/img/home/home_new18.jpg"),
        },
        {
          img: require("../assets/img/home/home_new19.jpg"),
        },
        {
          img: require("../assets/img/home/home_new20.jpg"),
        },
        {
          img: require("../assets/img/home/home_new21.jpg"),
        },
      ]
      let newDataList = [];
      let current = 0
      if (this.dataList && this.dataList.length > 0) {
        for (let i = 0; i <= this.dataList.length - 1; i++) {
          if (i % 3 !== 0 || i === 0) {	//数据处理成几张展示
            if (!newDataList[current]) {
              newDataList.push([this.dataList[i]])
            } else {
              newDataList[current].push(this.dataList[i])
            }
          } else {
            current++
            newDataList.push([this.dataList[i]])
          }
        }
      }
      this.dataList = [...newDataList]
    },
    onHover() {
      this.Transition = '';
      this.Transition2 = 'none';
      this.Transition3 = 'none';
      this.Transition4 = 'none';
      this.showA = true;
      this.showB = false;
      this.showC = false;
      this.showD = false;
    },
    onHover2() {
      this.Transform = '';
      this.Transition = 'none';
      this.Transition2 = '';
      this.Transition3 = 'none';
      this.Transition4 = 'none';
      this.showA = false;
      this.showB = true;
      this.showC = false;
      this.showD = false;
    },
    onHover3() {
      this.Transform = '';
      this.Transition = 'none';
      this.Transition2 = 'none';
      this.Transition3 = '';
      this.Transition4 = 'none';
      this.showA = false;
      this.showB = false;
      this.showC = true;
      this.showD = false;
    },
    onHover4() {
      this.Transform = '';
      this.Transition = 'none';
      this.Transition2 = 'none';
      this.Transition3 = 'none';
      this.Transition4 = '';
      this.showA = false;
      this.showB = false;
      this.showC = false;
      this.showD = true;
    },
    arrowLeftClick() {
      this.itemIndex--;
      if (this.itemIndex == 0) this.itemIndex = 3;
      this.currentIndex = 1;
      this.currentIndex2 = 1;
      this.currentIndex3 = 1;
    },
    arrowRightClick() {
      this.itemIndex++;
      if (this.itemIndex == 4) this.itemIndex = 1;
      this.currentIndex = 1;
      this.currentIndex2 = 1;
      this.currentIndex3 = 1;
    },
    onClick(value) {
      this.currentIndex = value;
    },
    onClick2(value) {
      this.currentIndex2 = value;
    },
    onClick3(value) {
      this.currentIndex3 = value;
    },
    moreClick() {
      const router = this.$router.resolve({path: '/training_system_s1'})
      window.open(router.href, '_blank')
    },
    moreClick2() {
      const router = this.$router.resolve({path: '/camo_detail'})
      window.open(router.href, '_blank')
    },
    moreClick3() {
      const router = this.$router.resolve({path: '/training_system_s3'})
      window.open(router.href, '_blank')
    },
    moreClick4() {
      const router = this.$router.resolve({path: '/introduction'})
      window.open(router.href, '_blank')
    }
  },
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}

/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.solution {
  width: 100%;
  height: 350px;
  background: #FFFFFF;
}

.solution h1 {
  color: rgba(37, 37, 37, 1);
  font-size: 24px;
  line-height: 134px;
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.solution-item {
  margin: 10px 350px;
  justify-content: space-between;
  /*display: flex;*/
  width: 1250px;
  height: 180px;
}

.solution-item1 {
  margin-right: 16px;
  position: relative;
  width: 288px;
  height: 180px;
  background-color: rgba(255, 255, 255, 1);
  /*box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);*/
  border-radius: 10px;
}

.solution-item1 span {
  position: absolute;
  left: 91px;
  top: 30px;
  display: inline-block;
  /*border-radius: 100%;*/
  width: 90px;
  height: 90px;
  /*background-color: rgba(52, 145, 229, 1);*/
}

/* 初始状态（第一个选中） */
/*.solution-item1:first-child span > img {*/
/*  transform: scale(1.2);*/
/*}*/

/* 清除所有hover */
/*.solution-item:hover .solution-img {*/
/*  transition: none;*/

/*}*/

.solution-item1 span:hover {
  cursor: pointer;
}

.solution-img {
  border-radius: 100%;
  /*height: 100%;*/
  /*width: 100%;*/
  transition-delay: 9999s;
  /*transition-delay: 0s*/
  height: 90px;
  width: 90px;
}

.solution-img:hover {
  transform: scale(1.2);
  transition-delay: 0s;
}

.solution-text {
  position: absolute;
  top: 138px;
  left: 110px;
  width: 100px;
  color: #252525;
  font-weight: 500;
  font-size: 14px;
}

.solution-text2 {
  position: absolute;
  top: 160px;
  left: 98px;
  text-align: center;
  font-weight: 600;
  color: #909090;
  font-size: 14px;
  line-height: 28px;
}

.solution-text3 {
  position: absolute;
  top: 160px;
  left: 102px;
  text-align: center;
  font-weight: 600;
  color: #909090;
  font-size: 14px;
  line-height: 28px;
}

.solution-text4 {
  position: absolute;
  top: 160px;
  left: 110px;
  text-align: center;
  font-weight: 600;
  color: #909090;
  font-size: 14px;
  line-height: 28px;
}

.scheme {
  width: 100vw;
  height: 200px;
  /*background: #f8f8f8;*/
}

.scheme_cont {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  /*padding-top: 91px;*/
}

.scheme_cont h1 {
  text-align: center;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 45px;
}

.scheme_item {
  width: 1200px;
  height: 340px;
  margin-top: 45px;
}

.scheme_item1 {
  display: flex;
  height: 100%;
}

.scheme_item1 img {
  height: 100%;
}

.scheme_item_text {
  background: #ffffff;
  margin-top: 40px;
  width: 740px;
  height: 300px;
  box-shadow: 0px 0px 63px 0px rgba(185, 185, 185, 0.25);
  opacity: 1;
  border-radius: 0px 0px 0px 0px;
}

.scheme_item_text h2 {
  margin-top: 52px;
  margin-left: 86px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #8AB3DF;
  line-height: 33px;
  width: 372px;
  border-bottom: 1px solid #A5A5A5
}

.scheme_item_text h3 {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #8AB3DF;
  line-height: 33px;
}

.scheme_item_text span {
  width: 568px;
  height: 140px;
  margin-top: 24px;
  margin-left: 86px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.scheme_item1 {
  margin-bottom: 40px;
}

.scheme_item1_block {
  width: 550px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 86px;
}

.scheme_item1_block .div3 {
  margin: 40px 24px 38px 0;
  line-height: 40px;
  text-align: center;
  width: 172px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d7d7d7;
}

.scheme_item1_block .div4 {
  margin-top: -10px;
}

.scheme_item1_block .div5 {
  margin-top: -10px;
}

.scheme_item1_block div {
  margin: 40px 24px 38px 0;
  line-height: 40px;
  text-align: center;
  width: 140px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d7d7d7;
}

.product {
  /*padding-top: 200px;*/
  width: 100%;
  height: 1054px;
  background-image: url("../assets/img/home/product_background.png");
  background-size: contain;
}

.product-top {
  width: 100%;
  padding-top: 200px;
}

.product-content {
  width: 1210px;
  height: 410px;
  margin: auto;
  padding-top: 50px;
  display: flex;
}

.product-content-bottom {
  width: 26px;
  height: 26px;
  margin-top: 150px;
  cursor: pointer;
}

.product-content-bottom img {
  width: 26px;
  height: 26px;
}

.product-content-bottom2 {
  width: 26px;
  height: 26px;
  margin-left: 23px;
  margin-top: 150px;
  cursor: pointer;
}

.product-content-bottom2 img {
  width: 26px;
  height: 26px;
}

.product-content-item {
  margin-left: 25px;
  display: flex;
}

.product-content-left {
  width: 438px;
  height: 400px;
  margin-left: 50px;
}

.product-content-left img {
  width: 438px;
  height: 400px;
}

.div1More {
  width: 150px;
  height: 36px;
  border-radius: 38px 38px 38px 38px;
  opacity: 1;
  margin-left: 350px;
  border: 1px solid #000000;
  cursor: pointer;
}

.div1More h5 {
  margin-left: 50px;
  /*width: 150px;*/
  height: 36px;
  flex-direction: row;
  align-items: center;
  display: flex;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
}

.product-content-right {
  width: 570px;
  /*height: 200px;*/
  margin-top: 50px;
  margin-left: 50px;
}

.product-content-right-1 {
  width: 570px;
  height: 55px;
}

.product-content-right-2 {
  width: 570px;
  height: 250px;
}

.product-content-right-2 h2 {
  margin-top: 52px;
  margin-left: 50px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 33px;
}

.product-content-right-2 h3 {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 16px;
}

.product-content-right-2 span {
  width: 510px;
  /*height: 140px;*/
  margin-top: 24px;
  margin-left: 50px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 20px;
}

.product_div2 {
  margin-top: 24px;
  margin-left: 50px;
  display: flex;
}

.product_img_mini_div1 {
  width: 68px;
  height: 46px;
  border-radius: 3px 3px 3px 3px;
  opacity: 1;
  border: 1px solid #EBEBEB;
  cursor: pointer;
}

.product_img_mini_div1.active {
  border: 1px solid #A7C6E7;
}

.product_img3 {
  width: 39px;
  height: 37px;
  margin-top: 5px;
  margin-left: 12px;
}

.product_img_mini_div2 {
  margin-left: 10px;
  width: 68px;
  height: 46px;
  border-radius: 3px 3px 3px 3px;
  opacity: 1;
  border: 1px solid #EBEBEB;
  cursor: pointer;
}

.product_img_mini_div2.active {
  border: 1px solid #A7C6E7;
}

.product_img4 {
  width: 61px;
  height: 36px;
  margin-top: 5px;
  margin-left: 3px;
}

.product-bottom {
  width: 145px;
  height: 30px;
  margin: 0 auto;
  display: flex;
  margin-top: 40px;
}

.product-bottom-item1 {
  width: 45px;
  height: 6px;
  background: #EFEFEF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.product-bottom-item1.active {
  background: #8AB3DF;
}

.product-bottom-item2 {
  width: 45px;
  height: 6px;
  background: #EFEFEF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-left: 5px;
}

.product-bottom-item2.active {
  background: #8AB3DF;
}

.product-bottom-item3 {
  width: 45px;
  height: 6px;
  background: #EFEFEF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-left: 5px;
}

.product-bottom-item3.active {
  background: #8AB3DF;
}

.product-carousel {
  width: 1210px;
  height: 410px;
  margin: auto;
  padding-top: 50px;
}

/deep/ .el-carousel__container {
  width: 1210px;
  height: 510px;
}

/deep/ .el-carousel__arrow--left {
  left: 16px;
}

/deep/ .el-carousel__arrow {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  transition: .3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, .11);
  color: #FFF;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}

/deep/ .el-carousel__arrow--right, .el-notification.right {
  right: 16px;
}

/deep/ .el-carousel__button {
  width: 45px;
  height: 6px;
}

.product h1 {
  color: #252525;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.product-line {
  margin: auto;
  width: 372px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #303030;
}

.product_item_text {
  /*background: #ffffff;*/
  /*margin-top: 40px;*/
  /*width: 740px;*/
  /*height: 300px;*/
  /*box-shadow: 0px 0px 63px 0px rgba(185, 185, 185, 0.25);*/
  /*opacity: 1;*/
  /*border-radius: 0px 0px 0px 0px;*/
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
}

.product_item_text h2 {
  margin-top: 52px;
  margin-left: 50px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 33px;
}

.product_item_text h3 {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #252525;
  line-height: 33px;
}

.product_item_text span {
  width: 450px;
  /*height: 140px;*/
  margin-top: 24px;
  margin-left: 50px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.product_div {
  margin-top: 24px;
  margin-left: 50px;
}

.product_img {
  width: 39px;
  height: 37px;
}

.product_img2 {
  width: 51px;
  height: 29px;
}

/*默认按钮的颜色大小等*/
/deep/ .el-carousel__button {
  width: 45px;
  height: 7px;
  /*border: none;*/
  /*border-radius: 20px;*/
  background: #EFEFEF;
  opacity: 1;
}

/*选中图片的颜色*/
/deep/ .is-active .el-carousel__button {
  background: #8AB3DF;
  opacity: 1;
}

.story_item {
  width: 100%;
  height: 825px;
  position: relative;
  display: flex;
  margin-top: 120px;
}

.story_item img {
  height: 100%;
}

.story_item_text {
  position: absolute;
  top: 552px;
  right: 76px;
  width: 917px;
  height: 503px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.story_item_text > h1 {
  text-align: left;
  margin-top: 69px;
  margin-left: 79px;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #252525;
  line-height: 33px;
}

.story_item_text > h1 > span {
  color: #B0B0B0;
  font-weight: 500;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
}

.story_item_text p {
  margin-top: 30px;
  margin-left: 79px;
  width: 750px;
  /*height: 256px;*/
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #939393;
  line-height: 16px;
}

.story_more_div {
  width: 100%;
}

.story_more_p {
  line-height: 162px;
  font-size: 14px;
  margin-left: 750px;
  font-weight: 600;
  color: #000000;
  cursor: pointer;
}

.story {
  width: 100%;
  height: 963px;
  /*position: relative;*/
  /*background-color: #444444;*/
  /*display: flex;*/
  background-image: url("../assets/img/home/story_background.png");
  background-size: contain;
}

.service {
  width: 100%;
  height: 950px;
  background-image: url("../assets/img/home/service_background.png");
  background-size: contain;
}

.service h1 {
  color: #252525;
  font-weight: 600;
  font-size: 24px;
  padding-top: 60px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.service h2 {
  color: #B0B0B0;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.service_cont {
  width: 1210px;
  margin: 0 auto;
  padding-top: 50px;
}

.service_item {
  width: 1210px;
  height: 563px;
  margin-top: 45px;
}

.service_item1 {
  width: 1210px;
  height: 563px;
  display: flex;
}

.service_item_text {
  /*margin-top: 1px;*/
  width: 458px;
  height: 130px;
}

.service_item_text2 {
  /*margin-top: 11px;*/
  height: 433px;
  width: 456px;
  /*height: 456px;*/
}

.service_img {
  width: 458px;
  height: 429px;
}

.service_contact_img {
  width: 455px;
  height: 130px;
  padding-left: 30px;
}

.service_partners_img {
  width: 757px;
  height: 563px;
}

.service_item_text h2 {
  margin-top: 52px;
  margin-left: 86px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #8AB3DF;
  line-height: 33px;
  width: 372px;
  border-bottom: 1px solid #A5A5A5
}

.service_item_text h3 {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #8AB3DF;
  line-height: 33px;
}

.service_item_text span {
  width: 568px;
  height: 140px;
  margin-top: 24px;
  margin-left: 86px;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #939393;
  line-height: 28px;
}

.success {
  width: 100%;
  height: 200px;
  background: #FFFFFF;
}

.success h1 {
  color: #252525;
  font-weight: 600;
  font-size: 24px;
  padding-top: 60px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.success h2 {
  color: #B0B0B0;
  font-weight: 500;
  font-size: 16px;
  padding-top: 12px;
  /*line-height: 80px;*/
  text-align: center;
  font-family: PingFang SC, PingFang SC;
}

.case {
  width: 1921px;
  height: 1042px;
  background-image: url("../assets/img/home/case_background.png");
  background-size: contain;
}


.carouselBox {
  margin: 0 auto;
  width: 1210px;
  height: 510px;
  /*width: 1420px;*/
  /*height: 220px;*/
  background-color: #ffffff;
}

.carouselBox .carousel {
  width: 100%;
  height: 100%;
}

.carouselBox .carousel .el-car-item {
  width: 100%;
  height: 420px;
  display: flex;
}

.carouselBox .carousel .el-car-item .divSrc {
  width: 403px;
  height: 420px;
  background: #fff;
  /*margin-right: 46px;*/
}

.carouselBox .carousel .el-car-item .divSrc .img {
  width: 370px;
  height: 335px;
}

.carouselBox .carousel .el-car-item .divSrc .title {
  width: 90%;
  height: 80px;
  line-height: 80px;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #222222;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.carouselBox .el-car-item {
  width: 100%;
  display: flex;
}

.carouselBox .el-car-item img {
  width: 284px;
  height: 184px;
  margin-right: 20px;
  cursor: pointer;
}

.homepage_wrap {
  width: 100vw;
  margin: 0 auto;
  /*height: 1000px;*/
  height: 100%
}
</style>


